export const affiliateDataKeyTransformations = {
  checkout: 'co',
  checkin: 'ci',
  checkOut: 'co',
  checkIn: 'ci',
  source_property_id: 'spi',
} as const

export const affiliateDataKeysToDelete = ['id_affiliate']
